module.exports = __webpack_public_path__ + "79640df8968b69ffc3410f5baf4cda56.png";